export const FileUpload = ({ id, label, onChange, error, accept, value }) => {
    return (
      <>
        <label className="label" htmlFor={id}>
          {label}
        </label>
        <div className="file_uploader">
          <input type="file" accept={accept} id={id} onChange={onChange} />
          <label
            className={`form-control input ${error ? "is-invalid" : ""}`}
            htmlFor={id}
          >
            <span className="fileTag">Choose file</span>
            <span>{value ? value : "No file Chosen"}</span>
          </label>
          <span className="invalid-feedback">{error}</span>
        </div>
      </>
    );
  };